<template>
  <div v-if="regulationForm" class="py-8">
    <Card>
      <template #content>
        <RegulationPropertiesForm :form="regulationForm" @on-save="saveRegulation" @on-delete="confirmDelete"
                                  :disabled="!$auth.hasPermission('update:regulations')"/>
      </template>
    </Card>
  </div>
</template>

<script>
import RegulationPropertiesForm from "@/Forms/Regulation/RegulationPropertiesForm.vue";
import {mapStores} from "pinia";
import {useRegulationsStore} from "@/stores/regulations.js";

export default {
  name: "RegulationPropertiesView",
  components: {RegulationPropertiesForm},
  data() {
    return {
      regulationForm: undefined,
    }
  },
  emits: [
    'on-save',
    'on-delete',
  ],
  computed: {
    ...mapStores(useRegulationsStore)
  },
  methods: {
    async saveRegulation() {
      try {
        const response = await this.regulationForm.submit();
        this.$toast.add({
          severity: 'success',
          summary: this.$t('common.complete'),
          detail: this.$t('pages.admin.regulations.regulations.regulation.properties.regulation_properties_view.regulation_saved'),
          life: 3000
        });
        this.$emit('on-save');
        this.$router.replace({params: {...this.$route.params, regulation: response.data.id}});
      } catch (error) {
        //
      }
    },
    confirmDelete() {
      this.$confirm.require({
        group: 'delete',
        message: this.$t('pages.admin.regulations.regulations.regulation.properties.regulation_properties_view.are_you_sure_you_want_to_delete_this_regulation'),
        header: this.$t('pages.admin.regulations.regulations.regulation.properties.regulation_properties_view.delete_regulation'),
        accept: () => {
          this.deleteRegulation();
        },
        reject: () => {
          this.$toast.add({
            severity: 'info',
            summary: this.$t('common.cancelled'),
            detail: this.$t('pages.admin.regulations.regulations.regulation.properties.regulation_properties_view.regulation_was_not_deleted'),
            life: 3000
          });
        }
      });
    },
    async deleteRegulation() {
      try {
        if (this.$route.params.regulation !== 'NEW') {
          await this.regulationsStore.deleteRegulation(this.$route.params.regulation);
          this.$emit('on-delete');
        }
        this.$router.push({name: 'admin.regulations', params: {...this.$route.params, regulation: undefined}});
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    '$route.params.regulation': {
      async handler(newValue, oldValue) {
        if (newValue) {
          if (this.$route.params.regulation === 'NEW') {
            this.regulationForm = await this.regulationsStore.createRegulation();
          } else {
            this.regulationForm = await this.regulationsStore.editRegulation(this.$route.params.regulation);
            this.regulationForm.id = this.$route.params.regulation;
          }
        } else {
          this.regulationForm = undefined;
        }
      },
      immediate: true,
    }
  },
}
</script>
